import { signedDistanceInDirectionOf } from '@geometry'
import { round } from 'lodash-es'
import { interpolate } from '@utils'
import { createVerticalRoofSlabPayload } from './createVerticalRoofSlabPayload'

const roundPointsXY = (points: Point[]) => {
  return points.map(point => ({
    x: round(point.x, 8),
    y: round(point.y, 8),
    z: point.z,
  }))
}

export const createHipRoofShortSidePositions = (
  roofSlab: ShapeObject,
  offsetStart: number,
  offsetEnd: number,
  spacing: number,
) => {
  const spacingHalf = spacing / 2
  const p1 = roofSlab.shape.points[0]
  const p2 = roofSlab.shape.points[1]
  const p3 = roofSlab.shape.points[2]

  const baseAxisDirection = p2.sub(p1).normalize()
  const A1 = p1.add(baseAxisDirection.multiplyScalar(offsetStart))

  const distanceP1ToP3AlongBase = signedDistanceInDirectionOf(p1, p3, baseAxisDirection)
  const distanceP1ToB = distanceP1ToP3AlongBase - spacingHalf
  const B1 = p1.add(baseAxisDirection.multiplyScalar(distanceP1ToB))

  const C1Ratio = distanceP1ToB / distanceP1ToP3AlongBase
  const C1 = interpolate(p1, p3, C1Ratio)
  const D1Ratio = offsetStart / distanceP1ToP3AlongBase
  const D1 = interpolate(p1, p3, D1Ratio)
  const points1 = [A1, B1, C1, D1]

  const points1XYRounded8Decimals = roundPointsXY(points1)
  const verticalRoofSlab1 = createVerticalRoofSlabPayload(points1XYRounded8Decimals)

  const p3AtBase = p1.add(baseAxisDirection.multiplyScalar(distanceP1ToP3AlongBase))
  const A2 = p1.add(baseAxisDirection.multiplyScalar(distanceP1ToP3AlongBase + spacingHalf))
  const B2 = p2.add(baseAxisDirection.multiplyScalar(offsetEnd * -1))
  const C2Ratio = B2.distanceTo(p2) / p3AtBase.distanceTo(p2)
  const C2 = interpolate(p2, p3, C2Ratio)
  const D2Ratio = A2.distanceTo(p2) / p3AtBase.distanceTo(p2)
  const D2 = interpolate(p2, p3, D2Ratio)

  const points2 = [A2, B2, C2, D2]
  const points2XYRounded8Decimals = roundPointsXY(points2)
  const verticalRoofSlab2 = createVerticalRoofSlabPayload(points2XYRounded8Decimals)

  return [verticalRoofSlab1, verticalRoofSlab2]
}
